import { useMemo } from 'react';

export default function UpdatesSection() {
  const updates = useMemo(() => [
    {
      id: 1,
      time: '2026-07-30 14:30',
      title: '51吃瓜在线新增「深夜吃瓜」专区，汇集午夜档优质视频',
      tag: '新功能',
      type: 'feature' as const,
    },
    {
      id: 2,
      time: '2026-07-29 22:15',
      title: '暗网吃瓜直播频道完成画质升级，支持1080P高清推流',
      tag: '优化',
      type: 'update' as const,
    },
    {
      id: 3,
      time: '2026-07-29 10:00',
      title: '51cg吃瓜频道本月访问量突破百万，感谢每一位吃瓜人',
      tag: '里程碑',
      type: 'milestone' as const,
    },
    {
      id: 4,
      time: '2026-07-28 18:45',
      title: '吃瓜视频搜索功能上线，按话题、日期快速定位内容',
      tag: '新功能',
      type: 'feature' as const,
    },
    {
      id: 5,
      time: '2026-07-27 09:30',
      title: '在线暗网吃瓜移动端适配优化完成，手机浏览更流畅',
      tag: '优化',
      type: 'update' as const,
    },
    {
      id: 6,
      time: '2026-07-26 16:00',
      title: '暗网吃瓜视频评论系统升级，新增表情互动功能',
      tag: '升级',
      type: 'update' as const,
    },
    {
      id: 7,
      time: '2026-07-25 11:20',
      title: '51吃瓜视频在线资源库扩容，新增2000+精选视频',
      tag: '内容',
      type: 'milestone' as const,
    },
    {
      id: 8,
      time: '2026-07-24 08:00',
      title: '吃瓜专题合集功能发布，按事件整理全套吃瓜资源',
      tag: '新功能',
      type: 'feature' as const,
    },
  ], []);

  const tagColors: Record<string, string> = {
    '新功能': 'bg-accent-100 text-accent-700',
    '优化': 'bg-secondary-100 text-secondary-700',
    '里程碑': 'bg-primary-50 text-primary-600',
    '升级': 'bg-secondary-100 text-secondary-700',
    '内容': 'bg-primary-50 text-primary-600',
  };

  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 mt-3">51暗网吃瓜平台更新与运营快讯</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/60 hidden md:block"></div>

          <div className="space-y-0">
            {updates.map((update) => (
              <div key={update.id} className="flex gap-4 md:gap-6 py-4">
                <div className="hidden md:flex shrink-0 w-10 justify-center relative z-10">
                  <span className={`w-3 h-3 rounded-full mt-1.5 ${
                    update.type === 'feature' ? 'bg-accent-500' :
                    update.type === 'milestone' ? 'bg-primary-500' : 'bg-secondary-500'
                  }`}></span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className={`px-2 py-0.5 rounded text-xs font-medium ${tagColors[update.tag] || 'bg-background-200 text-foreground-500'}`}>
                      {update.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{update.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{update.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}